import {
  IStatementsRequestQuery,
  StatementStatus
} from "../../../services/api/banking/statements/types";
import {
  StatementQuerySort,
  StatementsFilters
} from "../../../modules/Statements/routes/RouteStatements";
import { UrlQuerySort } from "../../../shared/hooks/useUrlQuery";
import { WSTableColumnSortDirection } from "@wingspanhq/fe-component-library";

export const SORT_ORDER = {
  ASC: "asc",
  DESC: "desc"
} as const;

export type SortOrderType = (typeof SORT_ORDER)[keyof typeof SORT_ORDER];

export const createRequest = (
  filters: StatementsFilters,
  type: string,
  sort?: UrlQuerySort<keyof StatementQuerySort>
): IStatementsRequestQuery => {
  const filter = {
    status:
      type === StatementStatus.Archived
        ? StatementStatus.Archived
        : StatementStatus.Available,

    ...(type === StatementStatus.Archived
      ? {}
      : {
          // CST (UTC-6) is the timezone of the bank. Using ISO 8601
          // format for cross-browser compatibility (Safari rejects
          // non-standard date strings like "Jan 1 2026 00:00:00 CST").
          startDate: {
            ">=": new Date(`${type}-01-01T00:00:00.000-06:00`)
          },
          endDate: {
            "<=": new Date(`${type}-12-31T23:59:59.999-06:00`)
          }
        }),
    internalAccountType: filters.accountType
      ? {
          in: Array.isArray(filters.accountType)
            ? filters.accountType
            : [filters.accountType]
        }
      : undefined
  };

  const sortRequest = getSortRequest(sort);

  return {
    filter,
    sort: sortRequest
  };
};

export type StatementsQuerySort = {
  internalAccountType?: SortOrderType;
  startDate?: SortOrderType;
  // accountNumber?: SortOrderType;
};

const sortMap: Record<WSTableColumnSortDirection, SortOrderType | undefined> = {
  ascending: SORT_ORDER.ASC,
  descending: SORT_ORDER.DESC,
  none: undefined
};

function getSortRequest(
  urlQuerySort?: UrlQuerySort<keyof StatementQuerySort>
): StatementsQuerySort {
  if (urlQuerySort?.field === "internalAccountType") {
    return {
      internalAccountType: sortMap[urlQuerySort.direction]
    };
  }

  if (urlQuerySort?.field === "startDate") {
    return {
      startDate: sortMap[urlQuerySort.direction]
    };
  }

  // if (urlQuerySort?.field === "accountNumber") {
  //   return {
  //     accountNumber: sortMap[urlQuerySort.direction]
  //   };
  // }

  return {
    startDate: SORT_ORDER.DESC
  };
}
